import axios, {AxiosResponse} from "axios";
import Order, {InventoryChecklistEntry, OrderSendMail} from "@/model/Order";

const PATH = "/orders";

class OrderService {
  createOrder (data: OrderSendMail) {
    return axios.post(`${PATH}`, data);
  }

  updateOrder (orderId: number, data: OrderSendMail) {
    return axios.put(`${PATH}/${orderId}`, data);
  }

  findOrdersByTerm (term: string): Promise<AxiosResponse<Array<Order>>> {
    return axios.get(`${PATH}`, {
      params: {
        term: term
      }
    });
  }

  updateChecklist (orderId: string | number, checklistItems: Array<InventoryChecklistEntry>): Promise<AxiosResponse<Array<InventoryChecklistEntry>>> {
    return axios.post(`${PATH}/${orderId}/checklist`, checklistItems);
  }
}

export default new OrderService();
